import type { ReactNode } from 'react';

export interface PracticeRow {
  key: string;
  label: string;
  sub: string;
  icon: ReactNode;
  tone?: 'bad' | 'acc';
  meta?: ReactNode;
  metaBad?: boolean;
  onClick: () => void;
}

export function PracticeList({ title, rows }: { title: string; rows: PracticeRow[] }) {
  return (
    <section data-block="practice" className="flex flex-col gap-2.25">
      <h2 className="text-t11 text-faint tracking-kicker m-0 font-bold uppercase">{title}</h2>
      <div className="bg-card border-border rounded-card flex flex-col overflow-hidden border">
        {rows.map((r, i) => (
          <button
            key={r.key}
            type="button"
            onClick={r.onClick}
            style={{ animationDelay: `${(i * 0.03).toFixed(2)}s` }}
            className="text-foreground hover:bg-muted active:bg-muted animate-rise border-border flex min-h-13 w-full items-center gap-3 border-b px-3.75 py-3 text-left last:border-b-0 active:transform-none"
          >
            <span
              aria-hidden
              data-tone={r.tone}
              className="bg-muted text-muted-foreground data-[tone=acc]:text-accent-ink data-[tone=bad]:text-bad text-t11 flex size-8 flex-none items-center justify-center rounded-sm font-extrabold"
            >
              {r.icon}
            </span>
            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
              <span className="text-t15 font-bold text-pretty">{r.label}</span>
              <span className="text-t12 text-faint text-pretty">{r.sub}</span>
            </span>
            {r.meta != null && (
              <span
                data-bad={r.metaBad || undefined}
                className="text-t12h text-muted-foreground data-bad:text-bad flex-none font-extrabold tabular-nums"
              >
                {r.meta}
              </span>
            )}
            <span className="text-faint text-t15 flex-none" aria-hidden>
              →
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
